import DateRange from '@/vue-prop-types/DateRange'

export const PropDateRange = {
  props: {
    DateRange: {
      type: DateRange,
      required: false,
      default() {
        return new DateRange()
      },
    },
  },
}
